import { createSagaActionTypes } from '../../../utils/actionFactory';
export const GET_SETTINGS = 'GET_SETTINGS';
export const UPDATE_SETTINGS = 'UPDATE_SETTINGS';

export const actions = createSagaActionTypes('APP_SETTINGS', [
  GET_SETTINGS,
  UPDATE_SETTINGS
]);
